
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { EnumOpenMiniProgramType, EnumOpenMiniProgramPage } from '@xt/client/enums/mini'
import { openMiniProgram } from '@xt/client/utils/mini'

@Observer
@Component({
  components: {}
})
export default class extends Vue {
  @Prop({ default: false }) showLink: boolean

  hover: boolean = false
  hoverIndex: number = 0
  linkData = Object.freeze([
    {
      icon_box_bg: '#DCD2C4',
      qrcode_icon: this.$images.mine_im_xuantong,
      qrcode_text: this.ossProcessImg(this.$images.mine_im_xuantong_text, 56, 24),
      qrcode_text_class: 'qrcode-text-xuantong',
      qrcode_url: this.$images.mine_im_xuantong_qrcode,
      qrcode_tip: '笔墨点亮生活',
      open_mini_program: EnumOpenMiniProgramType.Uc,
      open_mini_program_path: EnumOpenMiniProgramPage.Uc
    },
    {
      icon_box_bg: '#CBCCC1',
      qrcode_icon: this.$images.mine_im_daily,
      qrcode_text: this.ossProcessImg(this.$images.mine_im_daily_text, 112, 28),
      qrcode_text_class: 'qrcode-text-daily',
      qrcode_url: this.$images.mine_im_daily_qrcode,
      qrcode_tip: '安心跟随，日日精进',
      open_mini_program: EnumOpenMiniProgramType.DayCourse,
      open_mini_program_path: EnumOpenMiniProgramPage.DayCourse
    },
    {
      icon_box_bg: '#EFE6E3',
      qrcode_icon: this.$images.mine_im_exhibition,
      qrcode_text: this.ossProcessImg(this.$images.mine_im_exhibition_text, 108, 28),
      qrcode_text_class: 'qrcode-text-exhibition',
      qrcode_url: this.$images.mine_im_exhibition_qrcode,
      qrcode_tip: '开启你的书画创作之旅',
      open_mini_program: EnumOpenMiniProgramType.Show,
      open_mini_program_path: EnumOpenMiniProgramPage.Show
    },
    {
      icon_box_bg: '#E1D6C9',
      qrcode_icon: this.$images.mine_im_study,
      qrcode_text: this.ossProcessImg(this.$images.mine_im_study_text, 108, 24),
      qrcode_text_class: 'qrcode-text-study',
      qrcode_url: this.$images.mine_im_study_qrcode,
      qrcode_tip: '入文房，养心境',
      open_mini_program: EnumOpenMiniProgramType.Wenfang,
      open_mini_program_path: EnumOpenMiniProgramPage.Wenfang
    }
  ])

  async handleOpenPCMini() {
    const { open_mini_program, open_mini_program_path } = this.linkData[this.hoverIndex]
    const { success, reason } = await openMiniProgram(open_mini_program, open_mini_program_path)

    console.warn(success, reason)

    if (reason) {
      this.$message.error(reason)
    }
  }

  getPopupContainer(triggerNode: HTMLElement) {
    const el: HTMLElement = document.querySelector('#container-position-box') ?? document.body
    return el
  }

  mouseEnterHandler(idx: number) {
    this.hoverIndex = idx
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
